//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: String,
        is_longer: Boolean,
    }
}
